import { CommandSet } from "../../command";
import { IEditCommand } from "./IEditCommand";

export class EditCommandSet<T, TCommand extends IEditCommand<T> = IEditCommand<T>> extends CommandSet<T, TCommand> implements IEditCommand<T> {
  constructor(commands?: TCommand[]) {
    super(commands);
  }

  undo(source: T): void {
    for (const command of this._commands.concat().reverse()) {  // 最後のコマンドから戻す.破壊しないようにconcat()でshallow copyしてから.
      command.undo(source); 
    }
  }
}
